import Vue from "vue";
import Vuex from "vuex";
import User from "./modules/user";
import oAuth from "./modules/oAuth/index";
import building from "./modules/building/index";
import DialogMessages from "./modules/Dialog/index";
import locale from "./modules/locale";

Vue.use(Vuex);

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  asideShow: false,
  darkMode: false
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
  toggle (state, variable) {
    state[variable] = !state[variable]
  }
}

export default new Vuex.Store({
  state,
  mutations,
  modules: {
    dialog: DialogMessages,
    auth:oAuth,
    user:User,
    building,
    locale,
  },
});